import { Component, OnInit } from '@angular/core';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import olMap from 'ol/Map';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { ProcedureLegModel } from 'src/app/models/procedure-leg';
import { Feature } from 'ol';
import LineString from 'ol/geom/LineString';
import * as olProj from 'ol/proj';
import { MapService } from 'src/app/services/map.service';
import { PointsService } from 'src/app/services/points.service';
import { ProcedureCoordinatePointModel } from 'src/app/models/procedure-coordinate-point';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { ProjectService } from 'src/app/services/project.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { cloneDeep, isBuffer } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SelectCoordinatePointComponent } from 'src/app/popup/select-coordinate-point/select-coordinate-point.component';
// import { PopupService } from '@ng-bootstrap/ng-bootstrap/util/popup';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { Coordinate } from 'ol/coordinate';
//import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { toLonLat } from 'ol/proj';
import { ProcedureModel } from 'src/app/models/procedure';
import { NavaidModel } from 'src/app/models/navaid';
import { NavaidsService } from 'src/app/services/navaids.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { FeatureType } from 'src/app/models/EnumTypes';
import { TabsService } from 'src/app/services/tabsService';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-procedures',
  templateUrl: './procedures.component.html',
  styleUrls: ['./procedures.component.scss'],
  standalone: false
})
export class ProceduresComponent implements OnInit {

  map:olMap;
  primaryDataActive : boolean = true;
  legsDataActive : boolean = false;
  navaidsDataActive : boolean = false;
  keyword = 'composedName';

  constructor(public procedureController : ProcedureControlService,
    private globalSelectionService : GlobalSelectionControlService,
    private toolsService : ToolsControlService,
    public selectCoordinatePointService : SelectCoordinatePointsControlService,
    private mapService : MapService,
    private pointsService : PointsService,
    public coordinatePointsController : CoordinatePointsService,
    private modalService : ModalControlService,
    private modalConfirmation : ModalConfirmationService,
    private navaidController : NavaidsService,
    public menuController : MenuManagementService,
    public tabsService: TabsService,
    public projectService: ProjectService) {
      this.map = this.mapService.getMap("map");
      this.selectCoordinatePointService.tempProcedureLeg = [];
     }

  ngOnInit(): void {}

  getAirports(coordpointid: string): any {
    return this.selectCoordinatePointService.airportsCoordinatePoints.filter((x: any) => x.coordpointid.toLocaleLowerCase().indexOf(coordpointid.toLocaleLowerCase()) > -1);
  }

  activateSelectOnMapFixPoint() {
    this.procedureController.fixPointSelectOnMapActive = true;
  }

  activateSelectOnMapLegStartPoint() {
    this.procedureController.startPointSelectOnMapActive = true;
  }

  activateSelectOnMapLegEndPoint() {
    this.procedureController.endPointSelectOnMapActive = true;
  }

  activateSelectOnMapAirport() {
    this.procedureController.airportSelectOnMapActive = true;
  }
  deleteCoordinatePointFromList() : void {
    let newProcedureCoordinatePoints: ProcedureCoordinatePointModel[] = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints);
    let selectedCoordPoint: ProcedureCoordinatePointModel = newProcedureCoordinatePoints.find( coord => coord.coordPoint.isselected);
    const index = newProcedureCoordinatePoints.indexOf(selectedCoordPoint, 0);
    newProcedureCoordinatePoints.splice(index, 1);
    for (let i = index; i< newProcedureCoordinatePoints.length; i++){
      newProcedureCoordinatePoints[i].sequencenumber--;
    }
    this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints = newProcedureCoordinatePoints;
    for (let j = 0; j< this.selectCoordinatePointService.tempProcedureLeg.length; j++){
      if (this.selectCoordinatePointService.tempProcedureLeg[j].startPoint.sequencenumber > selectedCoordPoint.sequencenumber){
        this.selectCoordinatePointService.tempProcedureLeg[j].startPoint.sequencenumber--;
        this.selectCoordinatePointService.tempProcedureLeg[j].endPoint.sequencenumber--;
      } else if(this.selectCoordinatePointService.tempProcedureLeg[j].startPoint.sequencenumber == selectedCoordPoint.sequencenumber
                || this.selectCoordinatePointService.tempProcedureLeg[j].endPoint.sequencenumber == selectedCoordPoint.sequencenumber){

        this.selectCoordinatePointService.deleteTempLegOnMap(this.selectCoordinatePointService.tempProcedureLeg[j]);
        this.selectCoordinatePointService.tempProcedureLeg.splice(this.selectCoordinatePointService.tempProcedureLeg.indexOf(this.selectCoordinatePointService.tempProcedureLeg[j], 0), 1);
        j--;
      }
    }
    const legsWithFixPoint = this.selectCoordinatePointService.getLegsWithFixPoint(this.selectCoordinatePointService.selectedProcedure);
    this.selectCoordinatePointService.deleteProcedureLegsOnMap(this.selectCoordinatePointService.selectedProcedure);
    this.selectCoordinatePointService.selectedProcedure.procedureLegs = [];
    this.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(this.selectCoordinatePointService.selectedProcedure, legsWithFixPoint, this.selectCoordinatePointService.tempProcedureLeg,this.procedureController.currentCreateProcedureID);
    this.removeCoordinatePointFromMap(selectedCoordPoint);

  }

  updateLegsOnMap(previousLeg : ProcedureLegModel, currentLeg : ProcedureLegModel) : void {
    let source = this.selectCoordinatePointService.getLayerSourceFromProcedureType(this.selectCoordinatePointService.selectedProcedure.proceduretype);

    source.getFeatures().forEach( feat =>{
      if((feat.getProperties().featureId == previousLeg.procedurelegid || feat.getProperties().featureId == currentLeg.procedurelegid) && this.selectCoordinatePointService.selectedProcedure.procedureid == feat.getProperties().procedureid){
        source.removeFeature(feat);
      }
    });

    let points = [];


    let newProcedureLeg : ProcedureLegModel = new ProcedureLegModel();
    newProcedureLeg.isstraightleg = previousLeg.isstraightleg;
    newProcedureLeg.startPoint = previousLeg.startPoint;
    newProcedureLeg.endPoint = currentLeg.endPoint;
    newProcedureLeg.fixPoint = previousLeg.fixPoint;
    newProcedureLeg.curvePoints = [];
    if(!previousLeg.isstraightleg){
      this.selectCoordinatePointService.calculateCurvePoints(newProcedureLeg);
    }

    //first
    points.push([
      newProcedureLeg.startPoint.coordPoint.longitude,
      newProcedureLeg.startPoint.coordPoint.latitude,
    ]);

    if(!newProcedureLeg.isstraightleg){



      newProcedureLeg.curvePoints.forEach(curvePoint => {
        points.push([curvePoint.longitude,curvePoint.latitude]);
      });
    }

    points.push([
      newProcedureLeg.endPoint.coordPoint.longitude,
      newProcedureLeg.endPoint.coordPoint.latitude,
    ]);

    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let newFeat = new Feature({
      geometry: new LineString(points),
      featureId: previousLeg.procedurelegid,
      type: this.selectCoordinatePointService.selectedProcedure.proceduretype,
      selectedOnManage: false,
      featureType : 2//procedure

    });

    source.addFeature(newFeat);
  }

  removeCoordinatePointFromMap(coordinatePoint : ProcedureCoordinatePointModel) : void {
    this.pointsService.getSelectedFeatures().forEach((feature) => {
      if(feature.getProperties().id == coordinatePoint.coordPoint.id){
        this.globalSelectionService.removeSelectedFeature(feature);
        this.pointsService.removeSelectedFeature(feature);
      }
    })
  }

  changeLegFormat() : void {
   //this.selectCoordinatePointService.isStraightlLeg = !this.selectCoordinatePointService.isStraightlLeg;

   let actualSelectedLeg : ProcedureLegModel = this.selectCoordinatePointService.selectedProcedureLeg;

   let filteredTempLegs : ProcedureLegModel[] = this.selectCoordinatePointService.tempProcedureLeg.filter( leg => leg.procedurelegid == actualSelectedLeg.procedurelegid);

    if(filteredTempLegs.length > 0){
      filteredTempLegs.forEach( leg => {
        if(this.selectCoordinatePointService.isStraightlLeg && !leg.isstraightleg){
          this.selectCoordinatePointService.deleteTempLegOnMap(leg);
          // this.selectCoordinatePointService.addLegToMap(actualSelectedLeg, this.selectCoordinatePointService.selectedProcedure);
          this.selectCoordinatePointService.selectLegFeature(actualSelectedLeg, this.selectCoordinatePointService.selectedProcedure);
        }else if (!this.selectCoordinatePointService.isStraightlLeg && leg.isstraightleg) {
          leg.isstraightleg = false;
          this.selectCoordinatePointService.addLegToMap(leg, this.selectCoordinatePointService.selectedProcedure, true);
          this.selectCoordinatePointService.selectLegFeature(leg, this.selectCoordinatePointService.selectedProcedure);
        }
        leg.isstraightleg = this.selectCoordinatePointService.isStraightlLeg;

      });
    }else if (this.selectCoordinatePointService.isStraightlLeg){
      this.selectCoordinatePointService.selectedProcedureLeg.ismodified = true;
      let newProcedureLeg : ProcedureLegModel = cloneDeep(this.selectCoordinatePointService.selectedProcedureLeg);
      newProcedureLeg.curvePoints = [];
      newProcedureLeg.fixPoint = null;
      newProcedureLeg.fixPointId = null;
      newProcedureLeg.ismodified = false;
      newProcedureLeg.isstraightleg = true;
      this.selectCoordinatePointService.addLegToMap(newProcedureLeg, this.selectCoordinatePointService.selectedProcedure, true);
      this.selectCoordinatePointService.tempProcedureLeg.push(newProcedureLeg);
      this.selectCoordinatePointService.selectLegFeature(newProcedureLeg, this.selectCoordinatePointService.selectedProcedure);
    }
  }

  saveProcedure() : void {
    let selectedProcedure : ProcedureModel = this.selectCoordinatePointService.selectedProcedure;
    if (!this.validateProcedureIdentifier(selectedProcedure.procedureid)){
      return;
    }

    this.checkAndOverrideLegModification();
    if(selectedProcedure.airport == null && (selectedProcedure.proceduretype == 'SID' || selectedProcedure.proceduretype == 'STAR')){
      this.modalConfirmation.showMesssageConfirmationModal("Procedures Management","Reference airport was not defined for this procedure. Do you want to continue and save without defining the reference airport?", "Yes", "No", () => this.saveProcedureInformation());
    }else {
      this.saveProcedureInformation();
    }
  }

  async saveProcedureInformation() {
    this.splitCriticalNavaidsFromNavaids(this.selectCoordinatePointService.selectedProcedure);

    if(await this.validateRequiredProcedureCoordinatePointsInformation()){
      this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.forEach(coordPoint => {
        coordPoint.coordPoint.published = true;
      });
      this.selectCoordinatePointService.selectedProcedure.navaids.forEach(navaid => {
        navaid = this.navaidController.getNavaidPayload(navaid);
      })
      this.selectCoordinatePointService.selectedProcedure.criticalNavaids.forEach(navaid => {
        navaid = this.navaidController.getNavaidPayload(navaid);
      })
      this.procedureController.saveProcedure(this.selectCoordinatePointService.selectedProcedure,this.tabsService);
      this.selectCoordinatePointService.removeAllSelectedLegs(this.selectCoordinatePointService.selectedProcedure);
      this.globalSelectionService.clearAllSelected();
    } else {
      this.modalService.showMesssageModal("Procedure Management", "Please correct the information regarding new Coordinate Point.");
    }
  }


  /* adaptProceduresCoordinatePoints() : void {
     this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.forEach( procCoord => {
      procCoord.coordPoint.latitude = procCoord.coordPoint.l
    })
  }*/

  splitCriticalNavaidsFromNavaids(proc : ProcedureModel) {
    proc.criticalNavaids = [];
    var i = proc.navaids.length
    while (i--) {
        if (proc.navaids[i].critical) {
          proc.criticalNavaids.push(proc.navaids[i]);
          proc.navaids.splice(i, 1);
        }
    }
  }

  async validateRequiredProcedureCoordinatePointsInformation() : Promise<boolean> {
    if (this.coordinatePointsController)
    for (const point of this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints){
      if (!(await this.validateProcedureCoordinatePoints(point.coordPoint, false))){
        return false;
      }
    }
    return true;
  }

  checkAndOverrideLegModification() {
    this.selectCoordinatePointService.selectedProcedure.procedureLegs.forEach( leg => {
      if(leg.ismodified){
        let old_sequence_number : number = leg.sequencenumber;
        let modified_leg : ProcedureLegModel= this.selectCoordinatePointService.tempProcedureLeg.find(leg_aux => leg_aux.procedurelegid == leg.procedurelegid);
        modified_leg.sequencenumber = old_sequence_number;
        var index = this.selectCoordinatePointService.selectedProcedure.procedureLegs.indexOf(leg);

        if (index !== -1) {
          this.selectCoordinatePointService.selectedProcedure.procedureLegs[index] = modified_leg;
        }
      }
    });
    this.selectCoordinatePointService.tempProcedureLeg = [];
  }

  async validateProcedureCoordinatePoints(newCoordPoint:CoordinatePointModel, showMessage = true) : Promise<boolean> {
    if (newCoordPoint.published){
      return true;
    }
    if (newCoordPoint.coordpointid == null || newCoordPoint.coordpointid == ""){
      return false;
    }
    if (this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.filter(proc_coord => proc_coord.coordPoint.coordpointid == newCoordPoint.coordpointid).length > 1) {
      showMessage ? this.modalService.showMesssageModal("Illegal Value Insertion","ID already in use for another new Coordinate Point"): false;
      return false;
    }
    else if (this.pointsService.getAllCoordinatePointsFeaturesFromLayers().findIndex(coordPoint => coordPoint.get("coordpointid") == newCoordPoint.coordpointid) != -1) {
      showMessage ? this.modalService.showMesssageModal("Illegal Value Insertion","ID already in use for another Coordinate Point"): false;
      return false;
    }
    const duplicates = await this.coordinatePointsController.getCoordinaPointsDuplicates(newCoordPoint.coordpointid);
    if (duplicates) {
      showMessage ? this.modalService.showMesssageModal("Illegal Value Insertion","ID already in use for another Coordinate Point"): false;
      return false;
    }
    if (newCoordPoint.name == ''){ // dont add this verification in the first if, it is supposed to be here
      return false;
    }
    return true;
  }

  validateProcedureIdentifier(procedureId) : boolean {
    if (procedureId == this.selectCoordinatePointService.originalProcedureID){
      return true;
    }
    const hasTempId = function(id){
      return id != null && (id.toString() as string).toUpperCase().includes("TEMP");
    }
    const idIsUsed: boolean = this.pointsService.getAllProceduresFeaturesFromLayers()
                              .findIndex(proc => proc.get("procedureid") == procedureId
                              && !hasTempId(proc.get("id"))) != -1;

    if (idIsUsed) {
      this.modalService.showMesssageModal("Illegal Value Insertion","Identifier already in use for another Procedure");
      //this.selectCoordinatePointService.selectedProcedure.procedureid = "";
      return false;
    }
    return true;

  }

  saveProcedureCoordinatePointTypeChange(event, coordPoint : ProcedureCoordinatePointModel) : void {
    coordPoint.procedurecoordpointtype = event.target.value;
  }

  saveProcedureCoordinatePointAltitudeChange(event, coordpoint : ProcedureCoordinatePointModel) : void {
    if (event.target.value >= 0 && event.target.value <= 60000){
      coordpoint.altitude = event.target.value;
    }else {
      this.modalService.showMesssageModal("Illegal Value Insertion","The Altitude value must be defined between 0 and 60000 ft.");
      event.target.value = "";
    }

  }


  selectAirport(event : CoordinatePointModel) : void {
    if (event.composedName == null){
      return;
    }
    this.selectCoordinatePointService.selectedProcedure.airport = event.composedName;
    this.selectCoordinatePointService.selectedProcedure.referenceAirportPk = event.id;
  }
  cancelProcedure():void{
    this.tabsService.closeTab();


    this.pointsService.deleteAllProceduresFromMap();
    this.pointsService.deleteCoordinatePointsFromMap();
    this.pointsService.fetchAndAddProcedures();
    this.pointsService.fetchAndAddCoordinatePoints();
    this.globalSelectionService.clearAllSelected();
  }

  private changePositionFunction(order : string) : void{
    let selectedCoordPoint = this.getProcedureSelectedCoordinatePoint();
    let sequenceNumberSelectedPoint = selectedCoordPoint.sequencenumber;

    let auxTable : ProcedureCoordinatePointModel[] = cloneDeep(this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints);

    if (order == 'up'){
      let index : number = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.indexOf(selectedCoordPoint, 0);
      if ((index-1) > -1){
        [auxTable[index - 1], auxTable[index]] = [
          auxTable[index],
          auxTable[index - 1],
        ];

      const tmpSeq = auxTable[index].sequencenumber;
      auxTable[index].sequencenumber = auxTable[index - 1].sequencenumber;
      auxTable[index - 1].sequencenumber = tmpSeq;

      this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints = auxTable;
      }
    }

    if (order == 'down'){
      let index : number = this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.indexOf(selectedCoordPoint, 0);
      if ((index+1) < this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.length){
         [auxTable[index], auxTable[index + 1]] = [
           auxTable[index + 1],
           auxTable[index],
        ];

      const tmpSeq = auxTable[index].sequencenumber;
      auxTable[index].sequencenumber = auxTable[index + 1].sequencenumber;
      auxTable[index + 1].sequencenumber = tmpSeq;

      this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints = auxTable;
      }
    }
    const legsWithFixPoint = this.selectCoordinatePointService.getLegsWithFixPoint(this.selectCoordinatePointService.selectedProcedure);

    this.selectCoordinatePointService.deleteProcedureLegsOnMap(this.selectCoordinatePointService.selectedProcedure);
    this.selectCoordinatePointService.selectedProcedure.procedureLegs = [];
    this.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(this.selectCoordinatePointService.selectedProcedure,legsWithFixPoint, this.selectCoordinatePointService.tempProcedureLeg);
  }

  changePosition( order : string) : void {
    let isCurveProcedure = false;
    for (const procedureLeg of this.selectCoordinatePointService.selectedProcedure.procedureLegs){
      if (!procedureLeg.isstraightleg && procedureLeg.fixPoint != null){
        isCurveProcedure = true;
        break;
      }
    }
    if (!isCurveProcedure){
      for (const tempLeg of this.selectCoordinatePointService.tempProcedureLeg){
        if (!tempLeg.isstraightleg && tempLeg.fixPoint != null){
          isCurveProcedure = true;
          break;
        }
      }
    }
    if (isCurveProcedure){
      this.modalConfirmation.showMesssageConfirmationModal("Change order of procedure waypoint",
      "If you change the order of the waypoints all the information regarding curved legs will be lost." +
      "You can manually add that information again after reordering. Do you want to continue?", "Yes", "No", () => {
        for (const procedureLeg of this.selectCoordinatePointService.selectedProcedure.procedureLegs){
          procedureLeg.isstraightleg = true;
          procedureLeg.fixPoint = undefined;
        }
        this.selectCoordinatePointService.tempProcedureLeg.forEach(leg => this.selectCoordinatePointService.deleteTempLegOnMap(leg));
        this.selectCoordinatePointService.tempProcedureLeg = [];
        this.changePositionFunction(order);
      });
    } else {
      this.changePositionFunction(order);
    }
  }

  // TODO : COPIED FROM THE PREVIOUS FUNCTION. NEEDS TO BE REFACTORED. THE ONLY DIFERENCE IS THAT THE LEG IS NOT SELECTED ON MAP
  createLegsFromProcedureCoordinatePointsAfterProcedureTypeChange(proc : ProcedureModel) {
    let sortedCoordPoints : ProcedureCoordinatePointModel[] = proc.procedureCoordinatePoints.sort((a,b) => (a.sequencenumber > b.sequencenumber) ? 1 : ((b.sequencenumber > a.sequencenumber) ? -1 : 0));
		for (let i = 0; i < sortedCoordPoints.length; i++) {
			if (i == 0) {
				let leg : ProcedureLegModel = new ProcedureLegModel();
				leg.startPoint = sortedCoordPoints[i];
				leg.sequencenumber = proc.procedureLegs.length + 1;
        let legId : number = proc.procedureLegs.length + 1;
        leg.procedurelegid = "l" + legId;

        proc.procedureLegs.push(leg);
			} else if (i == sortedCoordPoints.length - 1) {
        proc.procedureLegs[proc.procedureLegs.length - 1].endPoint = sortedCoordPoints[i];
			} else {
				if (sortedCoordPoints[i].coordPoint.type == 'FIX_POINT') {
					proc.procedureLegs[proc.procedureLegs.length - 1].fixPoint = sortedCoordPoints[i];
					proc.procedureLegs[proc.procedureLegs.length - 1].isstraightleg = false;
				} else {
					let leg : ProcedureLegModel = new ProcedureLegModel();
					leg.startPoint = sortedCoordPoints[i];
					proc.procedureLegs[proc.procedureLegs.length - 1].endPoint = sortedCoordPoints[i];
					leg.sequencenumber =  proc.procedureLegs.length + 1;
					leg.procedurelegid = "l" + proc.procedureLegs.length + 1;
					proc.procedureLegs.push(leg);
				}
			}
		}

    proc.procedureCoordinatePoints.forEach( point => {
      point.id = null;
    })
    proc.procedureLegs.forEach(leg => {
      this.selectCoordinatePointService.addLegToMap(leg, proc);
    })
	}

  getProcedureSelectedCoordinatePoint() : ProcedureCoordinatePointModel {
    let selectedCoordinatePoint : ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();

    this.selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints.forEach( coord => {
      if(coord.coordPoint.isselected){
        selectedCoordinatePoint = coord;
        return;
      }
    });
    return selectedCoordinatePoint;
  }

  addNavaidFromMap() : void {
    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    features.forEach( feat => {
      let navaid : NavaidModel = this.pointsService.transformFeatureInNavaid(feat);
      navaid = this.navaidController.getNavaidPayload(navaid);
      const found = this.selectCoordinatePointService.selectedProcedure.navaids.some(el => el.id == navaid.id);
      if(!found){
        this.selectCoordinatePointService.selectedProcedure.navaids.push(navaid);
      }
    });
  }

  selectProcedureNavaid(navaid : NavaidModel) {
    this.selectCoordinatePointService.selectedProcedure.navaids.forEach( elm => {
      if(navaid.id == elm.id){
        elm.isselected = true;
      }else {
        elm.isselected = false;
      }
    });
  }

  deleteSelectedNavaidsFromList(){
    this.selectCoordinatePointService.selectedProcedure.navaids.forEach(function(item, index, object) {
      if (item.isselected) {
        object.splice(index, 1);
      }
    });
  }
  // changeCritical( navaid : NavaidModel){
  //   this.selectCoordinatePointService.selectedProcedure.navaids.forEach( nav => {
  //     if(nav.id == navaid.id){
  //       nav.critical = !nav.critical;
  //     }
  //   })
  // }

  changeProcedureType(event) : void {
    const legsWithFixPoint = this.selectCoordinatePointService.getLegsWithFixPoint(this.selectCoordinatePointService.selectedProcedure);

    this.selectCoordinatePointService.deleteProcedureLegsOnMap(this.selectCoordinatePointService.selectedProcedure);
    this.selectCoordinatePointService.selectedProcedure.procedureLegs = [];
    this.selectCoordinatePointService.selectedProcedure.proceduretype = event.target.value;
    this.selectCoordinatePointService.createLegsFromProcedureCoordinatePoints(this.selectCoordinatePointService.selectedProcedure,legsWithFixPoint, this.selectCoordinatePointService.tempProcedureLeg);
  }

  deleteAllLegs(){
    this.selectCoordinatePointService.selectedProcedure.procedureLegs.forEach( temp_leg => {
        this.selectCoordinatePointService.deleteTempLegOnMap(temp_leg);
    });
    this.selectCoordinatePointService.selectedProcedure.procedureLegs = [];
  }

  activatePrimaryData() : void {
    this.primaryDataActive = true;
    this.legsDataActive = false;
    this.navaidsDataActive = false;
  }

  activateLegsData() : void {
    this.legsDataActive = true;
    this.primaryDataActive = false;
    this.navaidsDataActive = false;
  }

  activateNavaidsData() : void {
    this.navaidsDataActive = true;
    this.primaryDataActive = false;
    this.legsDataActive = false;
  }

  isValueValid(type : string, value : any) : void {

    if (value != null) {
      switch(type) {
        case "Aircraft_Speed":
          if (!(Number.parseFloat(value) >= 1 && Number.parseFloat(value) <= 3.4028235E38)){
            this.selectCoordinatePointService.selectedProcedure.aircraftspeed = null;
            this.selectCoordinatePointService.aircraftSpeedValid = false;
          }else {
            this.selectCoordinatePointService.aircraftSpeedValid = true;
          }
          break;
        default:
          break;
      }
    }

  }

  selectNavaidRows() : void{
    this.selectCoordinatePointService.selectedProcedure.navaids.forEach( elm => {
      if(elm.isselected){
        let feat : Feature = this.pointsService.getNavaidFeatureFromLayers(elm.id);
        let layer : VectorLayerDMTR = this.pointsService.navaidsLayers.childLayers[0].layers.find((element) => element.id === elm.navaidtype.toLowerCase()).olLayer;
        this.globalSelectionService.selectNavaidOnMap(feat, layer);
      }
    });
  }
}
